export default function ReportExportDialogTemplate(data) {
    //language=HTML
    return `
        <section class="window-printing position-fixed">
            <div class="animate__animated d-none">
                <div class="row justify-content-between align-content-center bg-primary text-white m-0 px-4 py-3">
                    <span>تصدير المستندات</span>
                    <a role="button" class="btn-close-printing"><i class="fa-solid fa-xmark fa-1-5x"></i></a>
                </div>
                <div class="container">
                    <div class="row justify-content-center py-4">
                        <div class="col-md-3 col-4">
                            <a id="exportAsPDF" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/pdf.svg" width="60" height="60">
                                <p>Adobe PDF File</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsDOCX" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/docx.svg" width="60" height="60">
                                <p>Microsoft Office Word</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsXLS" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/excel-2007.svg" width="60" height="60">
                                <p>Microsoft Office Excel 2007</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsXLSX" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/excel-2000.svg" width="60" height="60">
                                <p>Microsoft Office Excel 2000</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsPPTX" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/pptx.svg" width="60" height="60">
                                <p>Office Powerpoint</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsODT" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/rtf.svg" width="60" height="60">
                                <p>OpenOffice SpreadSheet</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsODS" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/Galaxy_OOo3_writer-doc_256.png" width="60" height="60">
                                <p>OpenOffice SpreadSheet</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="exportAsRTF" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/Galaxy_OOo3_calc-doc_256.png" width="60" height="60">
                                <p>OpenOffice SpreadSheet</p>
                            </a>
                        </div>
                        <div class="col-md-3 col-4">
                            <a id="sendEmailWithResult" class="export-button text-center text-secondary d-flex flex-column align-items-center">
                                <img src="images/printIcons/email.svg" width="60" height="60">
                                <p>Send Report by Email</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>`;
}